import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import AccountManager from '@models/AccountManager';
import { Observable } from 'rxjs';
import {Ticket, TicketResponse} from "@models/support-portal";

@Injectable({
  providedIn: 'root'
})
export class SupportPortalService {
  private readonly controllerPath = 'api/support-portal';
  public readonly photoPath = `${this.controllerPath}/get-photo?urlParams=`;

  constructor(private http: HttpClient) {}

  getAccountManager(): Observable<AccountManager> {
    return this.http.get<AccountManager>(`${this.controllerPath}/get-account-manager`, { headers: { 'x-front-queue': 'true' } });
  }

  public sendReportToSupport(params: Partial<Ticket>) {
    return this.http.post<TicketResponse>(`${this.controllerPath}/ticket`, params)
  }

  unreadMessagesCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${this.controllerPath}/ticket/count-unread`, { headers: { 'x-front-queue': 'true' } });
  }
}
